import { connect } from 'react-redux';
import LaporanPeminjamDetail from '../../../views/Library/LaporanPeminjam/LaporanPeminjamDetail.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(LaporanPeminjamDetail);
